// 组件对象，大写
import crudEdit from './crudEditForSideModal.vue'
export default crudEdit
